import { createApiSlice } from "@common";
import {
  CRUD_PROSPECT_SOURCE,
  GET_PROSPECT_SOURCE_BY_PROSPECT_ID
} from "@routes";

const apiConfig = [
  {
    name: "addProspectSource",
    method: "post",
    url: CRUD_PROSPECT_SOURCE,
    stateKey: "message",
  },
  {
    name: "getProspectSourceByProspectId",
    method: "get",
    url: GET_PROSPECT_SOURCE_BY_PROSPECT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "prospectSource",
  apiConfig,
  customReducers
);
const prospectSourceSlice = slice;

export default prospectSourceSlice.reducer;

export const {
  addProspectSource,
  getProspectSourceByProspectId,
} = thunks;

export const { rowSelect } = actions;
